import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProjectFormSubmissionDetailViewTopBar } from "./TopBar"

export const projectFormSubmissionDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProjectFormSubmissionDetailViewTopBar,
}
